import React, { memo, useMemo } from 'react'
import Pagination, { IPaginationProps } from 'transfix-ui/components/Pagination'
import { makeStyles } from 'transfix-ui/core/styles'
import { SHIPMENTS_PER_PAGE, TEST_IDS } from '../../constants'

const useShipmentsNeedingAttentionPaginationStyles = makeStyles(theme => ({
  pagination: {
    marginTop: theme.spacing(3),
    textAlign: 'center',
  },
}))

export interface IShipmentsNeedingAttentionPaginationProps
  extends Pick<IPaginationProps, 'currentPage' | 'onPageChange'> {
  totalCount: number
}

const ShipmentsNeedingAttentionPagination = memo<IShipmentsNeedingAttentionPaginationProps>(
  ({ currentPage, onPageChange, totalCount }) => {
    const classes = useShipmentsNeedingAttentionPaginationStyles()

    const hasMultiplePages = useMemo(() => {
      return totalCount > SHIPMENTS_PER_PAGE
    }, [totalCount])

    const numberOfPages = useMemo(() => {
      return Math.ceil(totalCount / SHIPMENTS_PER_PAGE)
    }, [totalCount])

    return hasMultiplePages ? (
      <div className={classes.pagination} data-test={TEST_IDS.pagination}>
        <Pagination
          currentPage={currentPage}
          onPageChange={onPageChange}
          numberOfPages={numberOfPages}
          displayPageNumbers={false}
        />
      </div>
    ) : null
  }
)

export default ShipmentsNeedingAttentionPagination
